import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from './actions';

import ErrorBoundary from "../../shared/components/Error/ErrorBoundary";

import Loader from '../../shared/components/Loader/Loader';
//const DeviceSelectionComp = React.lazy(() => import("./components/deviceSelection"));
import DeviceSelectionComp from "./components/deviceSelection";
import * as CountryListActions from '../../shared/components/CountryListModal/actions';
import * as ReviewActions from "../ReviewPage/actions/getSections";
import * as remarksActions from '../Remarks/actions/index';
import * as confirmActions from '../Confirmation/actions/index';
import * as TravelDateActions from '../TravelDates/actions/index';
import Cookies from 'js-cookie';
import { isUnAuth, shouldRedirectToNsaTrip } from '../../shared/services/httpClient';
import xss from 'xss'
class DeviceSelectionContainer extends Component { // eslint-disable-line

  componentWillMount() {
    if (!isUnAuth() && shouldRedirectToNsaTrip(this.props.landingPage)) {
      window.location.href = xss(this.props.landingPage?.itpChangePlanNsaUrl || "/digital/nsa/secure/ui/intl/trip/");
    }
   }
  componentDidMount() {
    let isBack = false;
    const unAuthSessionId = Cookies.get('unAuthSessionId');
    console.log("cookie value",unAuthSessionId);
    let thisPageIndex = 4;
    if (reactGlobals) {
      if (reactGlobals.currentPageIndex > thisPageIndex) {
        isBack = true;
      }
      reactGlobals.currentPageIndex = thisPageIndex;
    }
    // this.props.actions.getSections();

    //let travelStartDate = new Date(this.props.location?.state?.data.departureDate);
    //let arrivalDate = new Date(this.props.location?.state?.data.arrivalDate);
    
    let postData = {};
  
    if (this.props.selectedTravelDate && JSON.stringify(this.props.selectedTravelDate) != '{}') {
      let travelStartDate = new Date(this.props.selectedTravelDate?.departureDate);
      let arrivalDate = new Date(this.props.selectedTravelDate?.arrivalDate);

      postData = {
        "travelStartDate": unAuthSessionId ? "" : this.getFormattedDate(travelStartDate) ,
        "travelEndDate":  unAuthSessionId ? "" :this.getFormattedDate(arrivalDate),
        "goBack": isBack ? "Y" : "N"
      }
      this.props.actions.deviceGoBackAction(postData.goBack);
      console.log("deviceGoBackFlag value 1",postData.goBack);
    }
    if ((postData === "" || JSON.stringify(postData) === '{}' || postData == null) && shouldRedirectToNsaTrip(this.props.landingPage)) {
      window.location.href = xss(this.props.landingPage?.itpChangePlanNsaUrl || "/digital/nsa/secure/ui/intl/trip/");
    }
    else
      this.props.actions.getSections(postData, this.props);
    
    this.props.confirmActions.setisConfirmLoadValue(false);
    Cookies.remove('unAuthSessionId');
    document.title = 'International plan_DeviceSelection'
  }
  getFormattedDate(date) {
    var year = date.getFullYear();
    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    return month + '/' + day + '/' + year;
  }
  render() {
    if (!this.props.isFetching_ITPDeviceselection) {
      return (
        <React.Fragment>
          <ErrorBoundary
           history={this.props.history}
            errorcode={this.props.statusCode_ITPDeviceselection}
            htmlMessage={
              this.props.errorMessage_ITPDeviceselection && this.props.errorMessage_ITPDeviceselection != ""
                ? this.props.errorMessage_ITPDeviceselection
                : undefined
            }
            htmlSubMessage={this.props.errorObj_ITPDeviceselection}
            htmlDescMessage={this.props.errorDesc_ITPDeviceselection}
            htmlActionName={this.props.actionName_ITPDeviceselection}
            htmlActionValue={this.props.actionValue_ITPDeviceselection}
          >
            {/* {this.props.isUpdatingDevice ? <Loader /> : null} */}
            {this.renderComponent()}

          </ErrorBoundary>
        </React.Fragment>
      );
    } else {
      const loadingImg = <Loader />;
      return <div>{loadingImg}</div>;
    }
  }
  renderComponent() {

    return (
      <DeviceSelectionComp {...this.props} />
    );
  }
}

const filterDevice = (Device) => {
  let top_device = [];
  try {
    let dArray = Device.deviceProductDetails;
    let dList = ['5G Smartphone', '4G Smartphone', '3G Smartphone', '5G Tablet', '4G Tablet', '3G Tablet', '4G Featurephone', 'Feature Phones', 'Basic Phones', 'Device'];
    let dList_lwr = dList.map(function (v) { return v.toLowerCase(); });

    dList_lwr.forEach(function (item) {
      top_device = [...top_device, ...(dArray.filter(e => e.sorDeviceCategory && e.sorDeviceCategory.toLowerCase() == item))];
    })
  }
  catch (e) { top_device = Device.deviceProductDetails; }
  return top_device;
}
const filterDeviceName = (deviceListArry, Device) => {

  let brandList = [];
  try {
    Device.brands.map(function (item) {
      let k = deviceListArry.filter(e => e.brandName == item);
      if (k && k.length > 0)
        brandList.push(item);
    });
  }
  catch (e) { }

  return brandList;
}
const sortDevice = (Device) => {
  try {
    let top_brand_lst = ['Apple', 'Google', 'LG', 'Motorola', 'Samsung'];
    let top_brand_lst_lwr = top_brand_lst.map(function (v) { return v.toLowerCase(); });

    let top_brand = [];
    top_brand_lst_lwr.forEach(function (item) {
      top_brand.push(Device.brands.filter(e => e.toLowerCase() == item)[0])
    })
    let non_top_brand = Device.brands.filter(function (e) {
      return !top_brand_lst_lwr.includes(e.toLowerCase());
    });

    Device.brands = top_brand.concat(non_top_brand);

    let top_device_lst = ['5G Smartphone', '4G Smartphone', '3G Smartphone', '5G Tablet', '4G Tablet', '3G Tablet', '4G Featurephone', 'Feature Phones', 'Basic Phones'];
    let top_device_lst_lwr = top_device_lst.map(function (v) { return v.toLowerCase(); });
    let top_device = [];
    top_device_lst_lwr.forEach(function (item) {
      top_device.push(Device.sorDeviceCategory.filter(e => e.toLowerCase() == item)[0])
    })

    let non_top_device = Device.sorDeviceCategory.filter(function (e) {
      return !top_device_lst_lwr.includes(e.toLowerCase());
    });

    //Device.sorDeviceCategory = top_device.concat(non_top_device);
    Device.sorDeviceCategory = top_device;
  } catch (e) { }

  return Device;
}

const mapStateToProps = (state) => {
  let data = state;
  const deviceSelectionForm = data.deviceSelectionForm;
  const progressBar = data?.ITP_Destination?.pageData?.body?.data?.destination?.progressBar?.tabs
  const unAuthflow = data.ITP_DeviceSelectionData && data.ITP_DeviceSelectionData?.pageData?.data?.unAuthflow;
  let Device = data?.ITP_DeviceSelectionData?.pageData?.data?.device;
  const deviceListArry = Device && filterDevice(Device);
  if (Device) {
    Device.brands = deviceListArry && filterDeviceName(deviceListArry, Device);
  }

  return {
    deviceData: unAuthflow ? sortDevice(data?.ITP_DeviceSelectionData?.pageData?.data?.device) : data?.ITP_DeviceSelectionData?.pageData?.data?.device,
    isFetching_ITPDeviceselection: data.ITP_DeviceSelectionData.isFetching,
    statusCode_ITPDeviceselection: data.ITP_DeviceSelectionData.statusCode,
    statusMessage_ITPDeviceselection: data.ITP_DeviceSelectionData.statusMessage,
    errorMessage_ITPDeviceselection: data.ITP_DeviceSelectionData.errorMessage,
    errorObj_ITPDeviceselection: data.ITP_DeviceSelectionData.errorObj,
    errorDesc_ITPDeviceselection: data.ITP_DeviceSelectionData.errorDesc,
    actionName_ITPDeviceselection: data.ITP_DeviceSelectionData.actionName,
    actionValue_ITPDeviceselection: data.ITP_DeviceSelectionData.actionValue,
    deviceGoBackFlag: data.ITP_DeviceSelectionData.deviceGoBackFlag,
    data: data.ITP_DeviceSelectionData && data.ITP_DeviceSelectionData.pageData && data.ITP_DeviceSelectionData.pageData.data,
    deviceSelectionForm,
    unAuthflow: unAuthflow,
    //deviceLisdata:  data?.ITP_DeviceSelectionData?.pageData?.data?.device?.deviceProductDetails,
    deviceLisdata: deviceListArry,
    compatiableCheckData: data.ITP_deviceCompatibleReducer.data,
    deviceCompatibleFlag: data.ITP_deviceCompatibleReducer.deviceCompatibleFlag,
    progressBarTabs: progressBar,
    selectedTravelDate: data?.ITP_TravelDate?.selectedTravelDate,
    countryListData: state.CountryListData?.CountryList?.data?.countryList,
    selectedDestList: state.ITP_Destination?.selectedDestList,
    landingPage: state?.MVALandingPageReducer?.pageData?.body?.data?.landingPage,

  };
};
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch),
  CountryListActions: bindActionCreators(CountryListActions, dispatch),
  ReviewActions: bindActionCreators(ReviewActions, dispatch),
  confirmActions: bindActionCreators(confirmActions, dispatch),
  TravelDateActions: bindActionCreators(TravelDateActions, dispatch),
  remarksActions: bindActionCreators(remarksActions, dispatch),
});

export { DeviceSelectionContainer, filterDevice, filterDeviceName, sortDevice, mapStateToProps, mapDispatchToProps };
export default connect(mapStateToProps, mapDispatchToProps)(DeviceSelectionContainer);